export default "__VITE_ASSET__7c9e85ca__"